export var MenuSettingsCategory;
(function (MenuSettingsCategory) {
    MenuSettingsCategory[MenuSettingsCategory["Settings"] = 55] = "Settings";
    MenuSettingsCategory[MenuSettingsCategory["Blog"] = 38] = "Blog";
})(MenuSettingsCategory || (MenuSettingsCategory = {}));



//////////////////
// WEBPACK FOOTER
// ./src/features/settings/MenuSettingsCategory.ts
// module id = 892
// module chunks = 3